<template>
  <div class="like-list">
    <div class="like-item hvr-glow hvr-shrink" v-for="item in goodsList" @click="toDetail(item.goodsId,item.goodsType)">
      <img :src="item.cover" alt="">
      <div class="book-content">
        <div class="name ellipsis-aRow" >{{item.goodsTitle}}</div>
        <div class="price-total">
          <div class="total">{{item.readCount ? item.readCount : 0}}人在读</div>
          <div class="price">￥{{item.prices}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import  { getResourceList } from "@/api/index/index.js";


export default {
  name: "like",
  props:['id'],
  data(){
    return{
      goodsList:[]
    }
  },
  mounted() {
    getResourceList({featuredId: this.id}).then(res=>{
      this.goodsList = res.data
    })
  },
  methods:{
    toDetail(id, type) {
      this.$router.push({
        path: "/bookstore/bookstoreDetail",
        query: {
          goodsId: id,
          goodsType: type,
        },
      });
    },
  }
}
</script>

<style scoped lang="scss">
  .like-list{
    width: 1400px;
    margin: 38px auto 60px;
    display: flex;
    overflow: hidden;
    .like-item{
      width: 238px;
      height: 298px;
      margin-left: 50px;
      cursor: pointer;
      &:first-of-type{
        margin-left: 0;
      }
      img{
        height: 240px;
      }
      .book-content{
        margin: 0 10px;
        .name{
          font-size: 22px;
        }
        .price-total{
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          line-height: 30px;
          .total{
            color: #797979;
          }
          .price{
            color: #128bff;
          }
        }
      }
    }
  }
</style>
